import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { navCategories, stats } from '@/mocks/home';

export default function AboutPage() {
  const faqItems = [
    {
      q: '今日看料是什么？',
      a: '今日看料是一个专注于娱乐八卦、网红爆料、明星黑料的吃瓜内容聚合平台。我们每日持续更新最新爆料内容，涵盖网红塌房、明星私聊、综艺黑幕等多个热门版块，是全网最全面的吃瓜入口。',
    },
    {
      q: '如何下载今日看料 APP？',
      a: '您可以访问我们的官方网站，在首页找到 APP 下载入口。目前支持 Android 和 iOS 两个平台。下载后即可第一时间接收最新爆料推送，随时随地吃瓜不停。',
    },
    {
      q: '今日看料的内容来源是什么？',
      a: '我们的内容主要来源于网友投稿、公开信息整理以及行业内部人士爆料。所有内容均经过审核团队核实后发布，我们坚持不做谣言的制造者，只做真相的搬运工。',
    },
    {
      q: '如何联系我们进行商务合作？',
      a: '您可以通过页面下方的联系方式与我们取得联系。我们欢迎广告投放、品牌合作、内容授权等多种形式的商务合作。商务合作邮箱：hello@hlw51.cn',
    },
    {
      q: '如何向我们投稿爆料？',
      a: '如果您有娱乐圈或网红圈的独家爆料内容，欢迎通过投稿邮箱 hello@hlw51.cn 向我们投稿。我们对投稿者信息严格保密，优质爆料内容将获得丰厚稿酬。',
    },
    {
      q: '今日看料的最新访问地址在哪里？',
      a: '为防止域名被屏蔽，请收藏我们的官方网址。如遇访问问题，可通过各大搜索引擎搜索"今日看料官网"或"今日看料最新地址"找到我们。',
    },
  ];

  return (
    <>
      <Navbar categories={navCategories} />
      <main className="pt-20 md:pt-24">
        <div className="max-w-[1000px] mx-auto px-4 md:px-6 pb-16">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
            <a href="/" className="hover:text-primary-500 transition-colors">首页</a>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </nav>

          <section id="intro" className="mb-16">
            <h1 className="text-3xl md:text-5xl font-heading font-black text-foreground-950 mb-6">
              关于今日看料
            </h1>
            <div className="bg-background-100 rounded-2xl p-6 md:p-10">
              <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-4">
                <strong>今日看料</strong>成立于2024年，是国内领先的娱乐八卦与网红爆料内容聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的娱乐爆料内容，让每一位用户都能第一时间掌握娱乐圈的最新动态。
              </p>
              <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-4">
                我们的团队由资深娱乐记者、数据分析师和技术工程师组成，通过多渠道信息采集和智能内容分发技术，确保平台内容的时效性和准确性。目前，今日看料已积累超过
                <strong>{stats[0].value}月活跃用户</strong>，累计爆料内容超过
                <strong>{stats[1].value}条</strong>，用户好评率达到
                <strong>{stats[2].value}</strong>。
              </p>
              <p className="text-foreground-700 text-base md:text-lg leading-relaxed">
                我们始终坚持"不做谣言的制造者，只做真相的搬运工"的核心理念，所有内容均经过多维度交叉验证后发布。我们相信，只有在真实的基础上，吃瓜才有意义。
              </p>
            </div>
          </section>

          <section id="stats" className="mb-16">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8">
              平台数据
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-background-100 rounded-2xl p-6 md:p-8 text-center">
                  <div className="text-2xl md:text-3xl font-heading font-black text-primary-500">
                    {stat.value}
                  </div>
                  <div className="mt-2 text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          <section id="reputation" className="mb-16">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8">
              用户口碑
            </h2>
            <div className="flex flex-col md:flex-row gap-4 md:gap-6">
              {[
                {
                  user: '资深吃瓜人小王',
                  comment: '关注今日看料半年多了，信息更新速度是真的快，而且内容都很劲爆。每天早上第一件事就是打开看今天有什么新瓜，已经成了我的日常习惯。',
                  date: '2026-07-05',
                },
                {
                  user: '娱乐圈边缘人',
                  comment: '用过好几个吃瓜平台，今日看料的内容质量明显更高。很多爆料后来都被证实是真的，说明他们的审核机制确实靠谱。推荐给所有吃瓜爱好者！',
                  date: '2026-07-03',
                },
                {
                  user: '热搜追踪者',
                  comment: 'APP 体验很棒，推送及时，界面简洁。最让我满意的是分类做得很好，想看哪类内容一目了然。黑料视频专区是我最常逛的版块。',
                  date: '2026-06-28',
                },
              ].map((item, idx) => (
                <div key={idx} className="flex-1 bg-background-100 rounded-2xl p-5 md:p-6">
                  <div className="text-primary-500 text-3xl font-serif leading-none mb-2 opacity-60">
                    &ldquo;
                  </div>
                  <p className="text-foreground-700 text-sm leading-relaxed">{item.comment}</p>
                  <div className="mt-4 flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center text-secondary-600 text-xs font-bold">
                      {item.user[0]}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{item.user}</p>
                      <p className="text-xs text-foreground-400">{item.date}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="faq" className="mb-16">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8">
              常见问题
            </h2>
            <div className="flex flex-col gap-3">
              {faqItems.map((item, idx) => (
                <details key={idx} className="group bg-background-100 rounded-2xl overflow-hidden">
                  <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                    <span className="text-foreground-800 font-medium text-sm md:text-base pr-4">{item.q}</span>
                    <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:rotate-45 transition-transform duration-200">
                      <i className="ri-add-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-foreground-600 text-sm leading-relaxed">{item.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          <section id="contact" className="mb-16">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              <div className="bg-background-100 rounded-2xl p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="mt-4 text-foreground-800 font-bold">商务合作</h3>
                <p className="mt-1 text-foreground-500 text-sm">广告投放 · 品牌合作</p>
                <a href="mailto:hello@hlw51.cn" className="block mt-3 text-primary-500 text-sm font-medium hover:underline">
                  hello@hlw51.cn
                </a>
              </div>
              <div className="bg-background-100 rounded-2xl p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-send-plane-line text-xl"></i>
                </div>
                <h3 className="mt-4 text-foreground-800 font-bold">内容投稿</h3>
                <p className="mt-1 text-foreground-500 text-sm">爆料 · 投稿 · 反馈</p>
                <a href="mailto:hello@hlw51.cn" className="block mt-3 text-primary-500 text-sm font-medium hover:underline">
                  hello@hlw51.cn
                </a>
              </div>
              <div className="bg-background-100 rounded-2xl p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-shield-check-line text-xl"></i>
                </div>
                <h3 className="mt-4 text-foreground-800 font-bold">侵权投诉</h3>
                <p className="mt-1 text-foreground-500 text-sm">版权 · 名誉 · 投诉</p>
                <a href="mailto:hello@hlw51.cn" className="block mt-3 text-primary-500 text-sm font-medium hover:underline">
                  hello@hlw51.cn
                </a>
              </div>
            </div>
          </section>

          <section id="address" className="mb-16">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8">
              最新地址
            </h2>
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-foreground-700 text-sm leading-relaxed mb-3">
                为防止域名被屏蔽导致无法访问，请务必收藏以下官方渠道：
              </p>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-3 p-3 bg-background-50 rounded-xl">
                  <i className="ri-link text-primary-500 text-lg"></i>
                  <span className="text-foreground-800 font-medium text-sm">官方网站：www.hlw51.cn</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-background-50 rounded-xl">
                  <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                  <span className="text-foreground-800 font-medium text-sm">APP 下载：扫描官网首页二维码或点击下载按钮</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-background-50 rounded-xl">
                  <i className="ri-search-line text-primary-500 text-lg"></i>
                  <span className="text-foreground-800 font-medium text-sm">搜索引擎：搜索"今日看料官网"或"今日看料入口"</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于今日看料 - 全网吃瓜第一入口',
            description: '今日看料是一个专注于娱乐八卦、网红爆料、明星黑料的吃瓜内容聚合平台。每日持续更新最新爆料内容。',
            url: 'http://hlw51.cn/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '今日看料',
              url: 'http://hlw51.cn/',
            },
            about: {
              '@type': 'Organization',
              name: '今日看料',
              url: 'http://hlw51.cn/',
              description: '今日看料是国内领先的娱乐八卦与网红爆料内容聚合平台。',
              contactPoint: [
                {
                  '@type': 'ContactPoint',
                  contactType: 'business cooperation',
                  email: 'hello@hlw51.cn',
                },
                {
                  '@type': 'ContactPoint',
                  contactType: 'content submission',
                  email: 'hello@hlw51.cn',
                },
              ],
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'http://hlw51.cn/' },
                { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://hlw51.cn/about' },
              ],
            },
            mainEntity: {
              '@type': 'FAQPage',
              mainEntity: faqItems.map((item) => ({
                '@type': 'Question',
                name: item.q,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.a,
                },
              })),
            },
          }),
        }}
      />
    </>
  );
}